import { useForm } from "react-hook-form";
const FormsSignUp = ({ title, handleRegister }) => {
    const { register, formState: { errors }, handleSubmit } = useForm();
    return (
        <>
            <form onSubmit={handleSubmit(handleRegister)}>
                <div className="form-wrapper">
                    <div className="form-text">
                        Добро пожаловать в список дел, войдите в аккаунт или создайте его
                    </div>
                    <div className="fom-controls">
                        <div className="input">
                            <input
                                style={errors.login && { border: "1px solid red" }}
                                {...register("login", { required: true })}
                                placeholder="Введите логин"
                            />
                            {errors.login?.type === 'required' && <p className="error" role="alert">Введите логин</p>}
                        </div>
                        <div className="input">
                            <input
                                style={errors.email && { border: "1px solid red" }}
                                {...register("email", { required: true })}
                                placeholder="Введите email"
                            />
                            {errors.email?.type === 'required' && <p className="error" role="alert">Введите почту</p>}
                        </div>
                        <div className="input">
                            <input
                                style={errors.password && { border: "1px solid red" }}
                                {...register("password", { required: true })}
                                placeholder="Введите пароль"
                                type="password"

                            />
                            {errors.password?.type === 'required' && <p className="error" role="alert">Введите пароль</p>}
                        </div>
                        <div className="form-send">
                            <button className="form-button" disabled={errors.password && errors.email}>
                                {title}
                            </button>
                        </div>
                    </div>
                </div>
            </form>
        </>
    )
}
export { FormsSignUp }